import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'SharedStackedStyles',
})(({ brandColors, spacing, breakpoints, typography }, props) => ({
  container: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionHeader: {
    marginBottom: spacing(3),

    [breakpoints.up('lg')]: {
      marginBottom: spacing(2),
    },
  },
  subhead: {
    fontWeight: 500,
    marginBottom: spacing(0),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
  body: {
    marginBottom: spacing(2),
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
    [breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  cta: {
    maxWidth: typography.pxToRem(141),
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center center',
    borderRadius: typography.pxToRem(16),
  },
  media: {
    marginBottom: spacing(2),
  },
}));

export default useStyles;
